// extracted by mini-css-extract-plugin
export default {"container":"style_container__39RuW","headerIcon":"style_headerIcon__q0DPQ","body":"style_body__5qvJ-","clientsTable":"style_clientsTable__gXrpe"};